import React from 'react';
import { SocialLink } from '../../types';

interface SocialIconProps {
  social: SocialLink;
  size?: 'sm' | 'md' | 'lg';
}

const SocialIcon: React.FC<SocialIconProps> = ({ social, size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-8 h-8 p-1.5',
    md: 'w-10 h-10 p-2',
    lg: 'w-12 h-12 p-2.5',
  };

  const iconClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
  };

  return (
    <a
      href={social.url}
      target="_blank"
      rel="noopener noreferrer"
      className={`rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-white/15 hover:scale-110 transition-all ${sizeClasses[size]}`}
      aria-label={social.platform}
      title={social.platform}
    >
      {social.icon ? (
        <img src={social.icon} alt={social.platform} className={iconClasses[size]} />
      ) : (
        <span className="text-xs font-bold">{social.platform.charAt(0)}</span>
      )}
    </a>
  );
};

export default SocialIcon;
